import produce from 'immer';

import {CidIdMap} from 'notebook/notes/NoteConstants';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {
  STRUCTURED_TABLE_MAPPING_CID_PREFIX,
  STRUCTURED_TABLE_COLUMN_MAPPING_CID_PREFIX,
  StructuredTableMapping,
} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingConstants';
import {
  StructuredTableMappingsGlobalState,
  StructuredTableMappingsStateManager,
} from 'notebook/structured-tables/structured-table-mappings/StructuredTableMappingsState';

/**
 * Add cids for StructuredTableMappings to a CID Map and saves them to Global State.
 * ⚠️ This mutates the cidIdMap
 */
export default function prepareStructuredTableMappingsForStore(
  fileId: string,
  cidIdMap: CidIdMap,
  structuredTableMappings: Array<StructuredTableMapping>
): Array<StructuredTableMapping> {
  const updatedStructuredTableMappings = produce(structuredTableMappings, (draftMappings) => {
    for (const structuredTableMapping of draftMappings) {
      addCid(structuredTableMapping, STRUCTURED_TABLE_MAPPING_CID_PREFIX, cidIdMap);
      for (const columnMapping of structuredTableMapping.structuredTableColumnMappings) {
        addCid(columnMapping, STRUCTURED_TABLE_COLUMN_MAPPING_CID_PREFIX, cidIdMap);
      }
    }
  });
  StructuredTableMappingsGlobalState.updateState(
    fileId,
    StructuredTableMappingsStateManager.setStructuredTableMappings(updatedStructuredTableMappings)
  );
  return updatedStructuredTableMappings;
}
